import { injectable } from 'inversify'

/**
 * Declarative half of viewport sensing — the media queries the app reacts to.
 *
 * A query string is configuration, not a module constant: the same literal was
 * copied into ShellPresenter (and its tests) as `DESKTOP_QUERY`. Owning it here
 * means one place to change the breakpoint, and NarrowViewportRepository /
 * ShellPresenter read it through DI the same way ThemePresenter reads
 * ThemeConfig.darkQuery.
 */
@injectable()
export class ViewportConfig {
  /**
   * Matches Tailwind's `sm` breakpoint. Below this the app is on a phone:
   * list tables shed their secondary columns (see the `compact` VM field) and
   * any width-conditional behaviour keys off NarrowViewportRepository.
   */
  readonly narrowQuery = '(max-width: 640px)'

  /**
   * Matches Tailwind's `md:` prefix — the width at which SidebarComponent
   * switches between push (desktop) and overlay (mobile) layout. ShellPresenter
   * uses it only to pick the *default* sidebar state on a first-ever visit.
   */
  readonly desktopQuery = '(min-width: 768px)'
}
